export enum AnalyticsEvent {
  OnboardingCompleted = 'onboarding_completed',
}

type EventParams = Record<string, unknown>

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export class Analytics {
  /**
   * Track an event to GA4 via GTM dataLayer
   */
  static trackEvent(eventName: string, eventParams?: EventParams): void {
    if (!import.meta.env.PROD) {
      return
    }

    // Check if dataLayer exists (GTM should be loaded)
    if (typeof window === 'undefined' || !window.dataLayer) {
      return
    }

    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    })
  }
}
